{
  "success": true,
  "message": "Oferta cancelada con éxito.",
  "status": "CANCELLED"
}
